import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { QuickBooksStatus } from '@/types/settings';

export function useTriggerQbSync() {
  const queryClient = useQueryClient();
  return useApiMutation<void, void>({
    mutationFn: () => apiPost<void>(operationsClient, settingsEndpoints.qbSync()),
    onSuccess: () => {
      toast.success('Sync started');

      // Poll until sync completes, then refresh all QB queries
      const poll = setInterval(async () => {
        try {
          const status = await apiGet<QuickBooksStatus>(
            operationsClient,
            settingsEndpoints.qbStatus(),
          );
          if (status.syncStatus !== 'syncing') {
            clearInterval(poll);
            void queryClient.invalidateQueries({ queryKey: settingsKeys.quickbooks() });
            toast.success('Sync completed');
          }
        } catch {
          clearInterval(poll);
        }
      }, 2000);

      // Safety: stop polling after 60s
      setTimeout(() => {
        clearInterval(poll);
        void queryClient.invalidateQueries({ queryKey: settingsKeys.quickbooks() });
      }, 60000);
    },
  });
}
